/* Kanadeal — selecteur de categories en haut du drawer menu (burger).
   Pastilles rondes a partir de window.KD_SHOP_CATS, mais avec des images dediees
   par categorie (KD_MENU_CAT_IMAGES) au lieu des images de collection.
   Inseree au-dessus du bouton "Tous les produits". Idempotent + MutationObserver. */
(function () {
  if (window.__kdMenuCatsInit) return;
  window.__kdMenuCatsInit = true;

  // Images dediees (fichiers Shopify) par handle de collection.
  var IMAGES = {
    'fleurs-cbd': 'https://cdn.shopify.com/s/files/1/0974/3286/3046/files/kd-cat-fleurs.jpg?v=1782156359',
    'pre-rolls-cbd': 'https://cdn.shopify.com/s/files/1/0974/3286/3046/files/kd-cat-prerolls.jpg?v=1782156359',
    'resines-cbd': 'https://cdn.shopify.com/s/files/1/0974/3286/3046/files/kd-cat-resines.jpg?v=1782156360',
    'zombie-cbd': 'https://cdn.shopify.com/s/files/1/0974/3286/3046/files/kd-cat-zombie.jpg?v=1782156359'
  };

  var ALL_SVG = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';

  function build() {
    var cats = window.KD_SHOP_CATS || [];
    if (!cats.length) return;
    document.querySelectorAll('.menu-drawer').forEach(function (drawer) {
      if (drawer.querySelector('.kd-menu-cats')) return;
      var anchor =
        drawer.querySelector('.menu-drawer__top-cta') ||
        drawer.querySelector('.menu-drawer__search-bar') ||
        drawer.querySelector('.menu-drawer__navigation');
      if (!anchor || !anchor.parentNode) return;
      var cur = window.KD_CUR_CAT;
      var box = document.createElement('div');
      box.className = 'kd-menu-cats';
      var head = document.createElement('div');
      head.className = 'kd-menu-cats__head';
      head.textContent = 'Catégories';
      box.appendChild(head);
      var track = document.createElement('div');
      track.className = 'kd-menu-cats__track';
      cats.forEach(function (c) {
        var a = document.createElement('a');
        a.className = 'kd-menu-cat' + (c.h === cur ? ' is-active' : '');
        a.href = c.u;
        var media = document.createElement('span');
        media.className = 'kd-menu-cat__media';
        var src = IMAGES[c.h] || c.img;
        if (src) {
          var img = document.createElement('img');
          img.className = 'kd-menu-cat__img';
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        } else {
          media.innerHTML = ALL_SVG;
        }
        a.appendChild(media);
        var name = document.createElement('span');
        name.className = 'kd-menu-cat__name';
        name.textContent = c.t;
        a.appendChild(name);
        track.appendChild(a);
      });
      box.appendChild(track);
      anchor.parentNode.insertBefore(box, anchor);
    });
  }

  function init() { build(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  var mo = new MutationObserver(function () { build(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
